import {Pill, TextSemiBold, TextSmallMedium} from '@hm/fundamental'
import {useTranslation} from 'react-i18next'

interface BrickCalculationRatioProps {
  brickShape1: string
  brickShape2: string
  mixingRatio: string
}

export const BrickCalculationRatio = ({
  brickShape2,
  brickShape1,
  mixingRatio
}: BrickCalculationRatioProps) => {
  const {t} = useTranslation()
  const ratios = mixingRatio.replace(' ', '').split(':')
  return (
    <div className="flex flex-col gap-2">
      <TextSmallMedium>{t('refraPlanning.brickCalculation.mixingRatio')}</TextSmallMedium>
      <div className="flex flex-row gap-1">
        <TextSemiBold>{ratios[0]}</TextSemiBold>
        <Pill type="primary" text={brickShape1} />
        <TextSemiBold>:</TextSemiBold>
        <TextSemiBold>{ratios[1]}</TextSemiBold>
        <Pill type="neutral" text={brickShape2} />
      </div>
    </div>
  )
}
